import {Outlet, createFileRoute} from "@tanstack/react-router";
import {routeMessages} from "../../../../../messages/routes.messages";

export const Route = createFileRoute("/_app/user-management/users/roles")({
  component: () => <Outlet />,
  staticData: {
    meta: {labelDescriptor: routeMessages.roles, moduleDescriptor: routeMessages.userManagement},
  },
});
